<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="driver">
                    <icon name="user"></icon>
                    คนขับรถ
                </b-nav-item>&nbsp
                <b-nav-item router-link to="driver-bonus" v-if="canViewAccounting || canViewDriver">
                    <icon name="coins"></icon>
                    โบนัสคนขับ
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="driver-transport-report"
                            v-if="canViewAccounting || canViewDriverAll">
                    <icon name="file"></icon>
                    รายงานบันทึกค่าเที่ยว
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="driver-config-bonus"
                            v-if="canViewAccounting || canViewDriverAll">
                    <icon name="cog"></icon>
                    ตั้งค่าโบนัสรถใหญ่
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="driver-config-province"
                            v-if="canViewAccounting || canViewDriverAll">
                    <icon name="cog"></icon>
                    ตั้งค่าจังหวัดใกล้เคียง
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    import {canViewAccounting,canViewDriverAll,canViewDriver} from "../../util/Permissions";

    export default {
        name: "driver-layout",
        computed:{
            canViewAccounting,
            canViewDriverAll,
            canViewDriver
        },
    }
</script>

<style scoped>

</style>
